export default __webpack_public_path__ + "static/media/cre.8ef26a8e.jpg";